import store from '@/store';

const ProfilePage = () => import('@/modules/settings/views/profile/ProfilePage');
const UserProfile = () => import('@/modules/settings/views/profile/UserProfile');
const CustomerPage = () => import('@/modules/settings/views/profile/CustomerPage');
const CustomerProfile = () => import('@/modules/settings/views/profile/CustomerProfile');
const CustomerUsers = () => import('@/modules/settings/views/profile/CustomerUsers');
const CountryOverview = () => import('@/modules/settings/views/settings/country/CountryOverview');
const RegistrationConfirmation = () => import("@/modules/settings/views/registration/RegistrationConfirmation");
const EmergencyCenterTable = () => import('@/modules/settings/views/settings/emergency-center/EmergencyCenterTable');
const MetaTable = () => import('@/modules/settings/views/settings/meta/MetaTable');
const OptionTable = () => import('@/modules/settings/views/settings/option/OptionTable');
const ProvinceTable = () => import('@/modules/settings/views/settings/province/ProvinceTable');
const RestExternalTable = () => import('@/modules/settings/views/settings/rest-external/RestExternalTable');
const SchedulerTable = () => import('@/modules/settings/views/settings/schedule/SchedulerTable');
const SettingTable = () => import('@/modules/settings/views/settings/setting/SettingTable');
const TagTable = () => import('@/modules/settings/views/settings/tag/TagTable');
const UpdateTable = () => import('@/modules/settings/views/settings/update/UpdateTable');
const DuplicateOverview = () => import("@/modules/settings/views/settings/duplicateMerge/DuplicateOverview");
const CustomerAdminSettings = () => import('@/modules/settings/views/settings/customer/CustomerAdminSettings')
const CustomerEditSettings = () => import('@/modules/settings/views/settings/customer/CustomerEditSettings')
const SubCustomers = () => import('@/modules/settings/views/profile/SubCustomers.vue')

const MODULE_PREFIX_URL = '/' + store.state.manager.settingsModule;

const routes = [
  {
    path: MODULE_PREFIX_URL + '/profile',
    name: 'Profile',
    component: ProfilePage,
    children: [
      {
        path: 'user',
        name: 'UserProfile',
        component: UserProfile,
        meta: {
          namespaces: ["components", "utils", 'enums', "country", "settings/customer"]
        }
      },
      {
        path: 'customer',
        name: 'Customer',
        component: CustomerPage,
        meta: {
          isMain: true,
          namespaces: ["components", "utils", "enums"]
        },
        children: [
          {
            path: 'profile',
            name: 'CustomerProfile',
            component: CustomerProfile,
            meta: {
              namespaces: ["components", "utils", "settings/customer", "country", "enums"],
              isMain: true
            }
          },
          {
            path: 'users',
            name: 'CustomerUsers',
            component: CustomerUsers,
            meta: {
              namespaces: ["components", "utils", "enums"],
              isMain: true
            }
          },
          {
            path: 'sub-customers',
            name: 'SubCustomers',
            component: SubCustomers,
            meta: {
              namespaces: ["components", "utils", "settings/customer", "country", "enums"],
              isMain: true
            }
          },
        ]
      },
    ]
    },
  {
    path: MODULE_PREFIX_URL + '/registration/confirm/:confirmationToken',
    name: 'RegistrationConfirmation',
    component: RegistrationConfirmation,
    meta: {
      isPublic: true,
      namespaces: ["country", "enums"]
    }
  },
  {
    path: MODULE_PREFIX_URL + '/emergency-center',
    name: 'EmergencyCenterTable',
    component: EmergencyCenterTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'country', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/metainfo',
    name: 'MetaTable',
    component: MetaTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/option',
    name: 'OptionTable',
    component: OptionTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/province',
    name: 'ProvinceTable',
    component: ProvinceTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'country', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/rest-external',
    name: 'RestExternalTable',
    component: RestExternalTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/scheduler',
    name: 'SchedulerTable',
    component: SchedulerTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/setting',
    name: 'SettingTable',
    component: SettingTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/tag',
    name: 'TagTable',
    component: TagTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/update',
    name: 'UpdateTable',
    component: UpdateTable,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/country',
    name: 'CountryOverview',
    component: CountryOverview,
    meta: {
      isAdmin: true,
      namespaces: ['settings/settings', 'dialog', 'snackbar']
    }
  },
  {
    path: MODULE_PREFIX_URL + '/customer',
    name: 'CustomerAdminSettings',
    component: CustomerAdminSettings,
    meta: {
      isAdmin: true,
      namespaces: ["settings/customer", "country"]
    }
  },
  {
    path: MODULE_PREFIX_URL + '/customer/edit/:id?',
    name: 'CustomerEditSettings',
    component: CustomerEditSettings,
    meta: {
      isAdmin: true,
      namespaces: ["settings/customer", "country", "components"]
    }
  },
  {
    path: MODULE_PREFIX_URL + '/merge',
    name: 'DuplicateMergeOverview',
    component: DuplicateOverview,
    meta: {
      isAdmin: true,
      namespaces: ["settings/settings", "country", "enums"]
    }
  },
]

export default routes;
